import showFilePickerPanel from './components/FilePickerPanelView';
import { FilePickerConfiguration, FilePickerResult } from 'owa-filepicker';

/**
 * Creates and opens the file picker component and returns back a promise that resolves
 * when user selects some files else it would reject.
 * @param selectionFilter The selection filter for the file picker
 */
export default function filePicker(
    filePickerConfiguration: FilePickerConfiguration
): Promise<FilePickerResult> {
    return new Promise<FilePickerResult>((resolve, reject) => {
        showFilePickerPanel(resolve, reject, filePickerConfiguration);
    });
}
